import React, { useState, useEffect } from 'react';
import ReactPlayer from 'react-player'
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../../../../../../../../../context/AuthContext";
import HandleVideoChange from '../../../Components/HandleVideoChange';
import Swal from 'sweetalert2'
import GeneralRequestHelper from '../../../../../../../../../Helpers/GeneralRequestHelper';
import axios from "axios";
import { getActiveTags } from './Services/TagService'; // Yeni oluşturduğumuz servis
import { getActiveCourses, getAllActiveSubjects, getSubjectsByCourseId } from './Services/ContentService';
import { updateContent } from './Services/ContentManagerService'; // Servisi import et
import { API_BASE_URL } from "../../../../../../../../../Helpers/apiConfig";

const VideoContent = (props) => {
    const { t, i18n } = useTranslation()
    const params = useParams();
    const navigate = useNavigate();
    const [url, setUrl] = useState([]);
    const [videoPath, setVideoPath] = useState(null);
    const [msg, setMsg] = useState([]);
    const { user } = useAuth();
    const [tags, setTags] = useState([]);
    const [loadingTags, setLoadingTags] = useState(true);
    const [tagId, setTagId] = useState([]);
    const [loadingSubjects, setLoadingSubjects] = useState(true);
    const [loadingCourses, setLoadingCourses] = useState(true);
    const [courses, setCourses] = useState([]);
    const [subjects, setSubjects] = useState([]);
    const [subjectId, setSubjectId] = useState([]);
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);

    const handletype1 = async (e) => {
        e.preventDefault();
        try {
            var questionn = {
                isDeleted: props.data.isDeleted,
                tagId: props.data.tagId,
                sortId: props.data.sortId,
                contentType: props.data.contentType,
                subjectId: props.data.subjectId,
                contentStr: videoPath,
                detail: props.data.detail,
                notfyText: props.data.notfyText,
                answer: props.data.answer,
                id: props.data.id
            }
            await GeneralRequestHelper("/api/admin/ContentManager/Update", "post", questionn, user.token).then(res => {
                if (res.status === 200) {
                    if (res.data['success']) {
                        Swal.fire({
                            title: "Başırılı!",
                            icon: "success",
                            confirmButtonText: `Soru listesi sayfasına Dön`,
                            timer: 5000,
                        }).then(() => {
                            navigate("/admin/questionlist");
                        });
                    }
                    else {
                        setMsg(res.data['message']);
                    }
                }
                else {
                    setMsg("Beklenmedik Bir Hata Oluştu. Tekrar Deneyiniz.");
                }
            });
        } catch (err) {
            setMsg(err.message);
        }



    }
    const handleChange = async (event) => {
        if (event.target.type === "textarea") {
            setVideoPath(event.target.value)
        }
        else if (event.target.type === "file") {

            const formData = new FormData();
            formData.append('FormFile', event.target.files[0]);
            try {
                await HandleVideoChange(formData, user.token, setVideoPath, setMsg).then(res => {
                    if (res.status === 200) {
                        if (res.data['success']) {
                            setVideoPath(res.data['data']['path'])
                            alert("Yüklendi");
                        }
                        else {
                            alert("hata")
                            setMsg(res.data['message']);
                        }
                    }
                    else {
                        setMsg("Beklenmedik Bir Hata Oluştu. Tekrar Deneyiniz.");
                    }
                });
            } catch (err) {
                setMsg(err.message);
            }
        }
    }

    const updateTag = async (e) => {
        e.preventDefault();

        // Veriyi hazırlıyoruz
        const payload = {
            ...props.data, // Mevcut tüm veriyi kopyala
            tagId: document.getElementById("tagId").value // Sadece tagId'yi güncelle
        };

        executeAction(payload);
    }
    const updateCourse = async (e) => {
        e.preventDefault();
        const selectedSubjectId = document.getElementById("subjectId").value;

        if (!selectedSubjectId) {
            return alert("Subject seçmediniz!");
        }

        const payload = {
            ...props.data,
            subjectId: selectedSubjectId // Sadece subjectId'yi güncelle
        };

        executeAction(payload);
    };

    const executeAction = async (payload) => {
        try {
            const res = await updateContent(payload, user.token);

            if (res.success) {
                Swal.fire({
                    title: "Başarılı!",
                    icon: "success",
                    confirmButtonText: `Soru listesi sayfasına Dön`,
                    timer: 500,
                }).then(() => {
                    window.location.reload();
                });
            } else {
                setMsg(res.message);
            }
        } catch (err) {
            setMsg("Beklenmedik Bir Hata Oluştu. Tekrar Deneyiniz.");
        }
    };
    const taglist = async () => {
        setLoadingTags(true);
        try {
            const activeTags = await getActiveTags(user.token);
            setTags(activeTags); // Doğru yöntem: State setter kullanmak
        } catch (err) {
            setMsg(err.message || "Etiket listesi yüklenirken hata oluştu.");
        } finally {
            setLoadingTags(false);
        }
    };
    const courseList = async () => {
        setLoadingCourses(true);
        try {
            const activeCourses = await getActiveCourses(user.token);
            setCourses(activeCourses); // Doğrudan state'e ata, .push() kullanma!
        } catch (err) {
            setMsg(err.message);
        } finally {
            setLoadingCourses(false);
        }
    };

    const subjectlist = async () => {
        setLoadingSubjects(true);
        try {
            const activeSubjects = await getAllActiveSubjects(user.token);
            setSubjects(activeSubjects);

            // Mevcut seçili konuyu bulma mantığı
            const currentSubject = activeSubjects.find(s => s.id === props.data.subjectId);
            if (currentSubject) {
                setSubjectId(currentSubject.subjectName + " - " + currentSubject.subjectDesc); // İsimleri birleştirerek göster
            }
        } catch (err) {
            setMsg(err.message);
        } finally {
            setLoadingSubjects(false);
        }
    };

    const courseselectchange = async (e) => {
        const selectedCourseId = e.target.value;
        setLoading(true);
        try {
            const filteredSubjects = await getSubjectsByCourseId(selectedCourseId, user.token);
            setSubjects(filteredSubjects); // Mevcut listeyi bu sonuçla değiştirir
        } catch (err) {
            setMsg(err.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        taglist();
        courseList();
        subjectlist();

        setTagId(JSON.parse(props.data.tagId));

        setUrl(props.data['contentStr'])
    }, []);

    return (
        <div>
            <form onSubmit={updateTag}>
                {loadingTags && <div>Veriler Yüklenirken Bir Hata Meydana Geldi!</div>}
                {!loadingTags && (
                    <div className='row' style={{ border: "1px solid black", padding: "10px" }}>
                        <div class="col-9">
                            <label for="tagId" class="form-label">{t("selecttag")}</label>
                            <select id="tagId" class="form-select" aria-label="Default select example">
                                {tags ? (
                                    tags && tags.map((dt) => {
                                        if (dt.id === tagId) {
                                            return (
                                                <option value={dt.id} selected>{dt.tagName}</option>
                                            );
                                        }
                                        else {
                                            return (
                                                <option value={dt.id}>{dt.tagName}</option>
                                            );
                                        }
                                    })
                                ) : (
                                    <p>{t("reloadWarning")}</p>
                                )
                                }
                            </select>
                        </div>
                        <div className='col-3'>
                            <br />
                            <div className='d-flex justify-content-center'>
                                <button type="submit" class="btn btn-primary btn-lg" >{t("update")}</button>
                            </div>
                        </div>

                    </div>

                )}
            </form>
            <br />
            <hr />
            <form onSubmit={updateCourse}>
                <div style={{ border: "1px solid black", padding: "10px" }}>
                    <br />
                    <span>Aktif Subject: {subjectId}</span>
                    {loadingCourses && <div>Veriler Yüklenirken Bir Hata Meydana Geldi!</div>}
                    {!loadingCourses && (
                        <div class="mb-3">
                            <label for="courseId" class="form-label">{t("selectCourse")}</label>
                            <select id="courseId" class="form-select" onChange={courseselectchange}>
                                <option key="" >{t("selectCourse")}</option>

                                {courses ? (
                                    courses && courses.map((dt) => {
                                        return (
                                            <option key={dt.id} value={dt.id}>{dt.courseName} -- {dt.courseDesc}</option>
                                        );
                                    })
                                ) : (
                                    <p>{t("reloadWarning")}</p>
                                )
                                }
                            </select>
                        </div>
                    )}

                    {loadingSubjects && <div>Veriler Yüklenirken Bir Hata Meydana Geldi!</div>}
                    {!loadingSubjects && (
                        <div class="mb-3">
                            <label for="subjectId" class="form-label">{t("selectSubject")}</label>
                            <select id="subjectId" class="form-select">
                                <option key="" >{t("selectSubject")}</option>

                                {subjects ? (
                                    subjects && subjects.map((dt) => {


                                        if (dt.id === data.subjectId) {
                                            return (
                                                <option value={dt.id} selected>{dt.subjectName}  // {dt.subjectDesc}</option>
                                            );
                                        }
                                        else {
                                            return (
                                                <option value={dt.id}>{dt.subjectName}  // {dt.subjectDesc}</option>
                                            );
                                        }
                                    })
                                ) : (
                                    <p>{t("reloadWarning")}</p>
                                )
                                }
                            </select>
                        </div>

                    )}
                    <div className='d-flex justify-content-center'>
                        <button type="submit" class="btn btn-primary btn-lg">{t("update")}</button>
                    </div>
                </div>
            </form>
            <hr />


            <br />
            <div className='player-wrapper' style={{ position: "relative" }} >
                <ReactPlayer
                    className='react-player'
                    url={url}
                    width='100%'
                    height="auto"
                    controls={true}
                />

            </div>
            <br />
            <form onSubmit={handletype1}>
                <div class="mb-3">
                    <label for="videocontent" class="form-label">{t("addVideo")}</label>
                    <input class="form-control" type="file" accept='video' onChange={handleChange} id="videocontent" name="videocontent" />
                </div>
                <div class="mb-3">
                    <label for="addvideos" class="form-label">{t("addVideobyUrl")}</label>
                    <textarea class="form-control" rows={1} type="text" onChange={handleChange} id="addvideos" name="addvideos" />
                </div>
                <div className='d-flex justify-content-center'>
                    <button type="submit" class="btn btn-primary btn-lg">{t("update")}</button>
                </div>
            </form>
        </div>
    );
};

export default VideoContent;